import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomButton = _resolveComponent("CustomButton")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "ma-2" }, {
    default: _withCtx(() => [
      (!_ctx.hidePreviousButton)
        ? (_openBlock(), _createBlock(_component_CustomButton, {
            key: 0,
            disabled: _ctx.disablePreviousButton,
            level: _ctx.$enums.ButtonLevels.Secondary,
            text: _ctx.previousLabel ?? 'Previous',
            class: "mr-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('previous')))
          }, null, 8, ["disabled", "level", "text"]))
        : _createCommentVNode("", true),
      (!_ctx.hideNextButton)
        ? (_openBlock(), _createBlock(_component_CustomButton, {
            key: 1,
            disabled: _ctx.disableNextButton,
            class: "ml-auto",
            level: _ctx.$enums.ButtonLevels.Primary,
            text: _ctx.nextLabel ?? 'Continue',
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('next')))
          }, null, 8, ["disabled", "level", "text"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}